import React, { useCallback } from 'react'
import { Label } from 'components/Form'
import { UploadFileStyles, WrapUploadFileButton, Label as Text, WrapHeaderUpload, WrapAudioContent, WrapFieldContent, WrapField, VisuallyHiddenInput, WrapAudio } from './Styled'
import { Cancel, Close } from '@mui/icons-material'
import { CircularProgress, IconButton, SvgIcon } from '@mui/material'
import { Img } from 'styles/GlobalStyle'
import { ReactComponent as UploadIcon } from 'assets/icons/Upload.svg'
import { useMutation } from '@tanstack/react-query'
import { removeFileFetch } from 'store/middlewares/newsletter.crud'
import Error from './Error'

const ImageUploaded = ({ file, cleanFile }) => (
    <div className='image-and-remove'>
        <div className='remove-button' onClick={cleanFile}>
            <Cancel className='remove-icon' />
        </div>
        <div className='image-preview'>
            <Img src={file.url || file.preview || file} alt="Uploaded" />
        </div>
    </div>
)

const AudioUploaded = ({ file }) => (
    <WrapAudio controls>
        <source src={URL.createObjectURL(file)} type="audio/mpeg" />
        Your browser does not support the audio element.
    </WrapAudio>
)

const UploadFile = (props) => {
    const { loading, disabled, size, type, name, placeholder, label, input = {}, showCleanIcon, section, className, mandatory } = props,
        { onChange, value } = input;

    const { mutateAsync: removeFile } = useMutation({
        mutationFn: removeFileFetch,
        mutationKey: "upload-file",
        onSuccess: () => {
            cleanFile()
        }
    })

    const handleChangeFile = useCallback(e => {
        const file = e.target.files[0];
        onChange(file)
    }, [])

    const handleChangeImage = useCallback(e => {
        const nFile = e.target.files[0];
        const reader = new FileReader();

        reader.onloadend = async () => {
            onChange({ preview: reader.result, file: nFile })
        };

        if (nFile) {
            reader.readAsDataURL(nFile);
        }
    }, [])

    const cleanFile = useCallback(() => {
        onChange(null)
    }, [])

    const removeImage = useCallback(() => {
        removeFile(value.file_name)
    }, [value])

    const item = {
        "image": {
            accept: "image/*",
            component: ImageUploaded,
            handleChange: handleChangeImage,
            boxHeight: 150,
            cleanFile: cleanFile,
            acceptMessage: "העלה קובץ מסוג תמונה"
        },
        "audio": {
            accept: "audio/*",
            component: AudioUploaded,
            handleChange: handleChangeFile,
            boxHeight: 50,
            cleanFile: cleanFile
        },
        "exel": {
            accept: ".xls,.xlsx",
            component: () => null,
            handleChange: handleChangeFile,
            boxHeight: 50,
            cleanFile: cleanFile
        },
        "docx": {
            accept: ".docx",
            component: () => null,
            handleChange: handleChangeFile,
            boxHeight: 50,
            cleanFile: cleanFile
        }
    }

    const UploadedComponent = item[type].component
    const UploadButtonComponent = props.buttonComponent || WrapUploadFileButton

    const buttonProps = props.buttonComponent ?
        {
            customComponent: "label"
        } :
        {
            component: "label"
        }

    return (
        <WrapField className={className} section={section}>
            <UploadFileStyles className={disabled && 'disabled2'} size="small">
                <WrapFieldContent>
                    {label && <Label label={label} mandatory={mandatory} />}

                    {value &&
                        <WrapHeaderUpload>
                            <Text>{value?.name}</Text>
                            {showCleanIcon &&
                                <IconButton size='small' onClick={cleanFile}>
                                    <Close fontSize='small' />
                                </IconButton>}
                        </WrapHeaderUpload>
                    }
                    <WrapAudioContent>
                        {value ?
                            <UploadedComponent file={value} cleanFile={item[type].cleanFile} />
                            :
                            <UploadButtonComponent
                                size={size}
                                action={() => { }}
                                color="thirdly"
                                role={undefined}
                                tabIndex={-1}
                                boxHeight={item[type].boxHeight}

                                {...buttonProps}
                            >
                                <VisuallyHiddenInput
                                    type="file"
                                    name={name}
                                    onChange={item[type].handleChange}
                                    accept={item[type].accept}
                                />
                                <div className='upload-file-message'>
                                    <div className='upload-message'>
                                        <SvgIcon size={size} component={UploadIcon} inheritViewBox />
                                        {placeholder || "העלאת קובץ"}
                                        {loading && <CircularProgress color="thirdly" size="20px" />}
                                    </div>
                                    {size != 'small' && item[type].acceptMessage &&
                                        <div>
                                            {item[type].acceptMessage}
                                        </div>}
                                </div>
                            </UploadButtonComponent>
                        }
                    </WrapAudioContent>
                </WrapFieldContent>
            </UploadFileStyles>
            <Error {...props} />
        </WrapField>
    )
}

export default UploadFile